import React from 'react';
import { Link, usePage } from '@inertiajs/inertia-react';
import Layout from '../Shared/Layout';
import Imgix, { Background } from 'react-imgix';
import List from '../Components/List/List';
import ListItem from '../Components/ListItem';

const Latest = ({ videos, showLeaving }) => {
  const { isLoggedIn, imgixURL } = usePage().props;
  return (
    <>
      <Background className='hero min-h-[25vh] mb-4 bg-cover'
                  src={`https://${imgixURL}/cms/homepage/jpm-plus-bg-20220912075650.jpg`}
                  imgixParams={{ auto: 'format', fit: 'crop', crop: 'center', blend: '000', bm: 'normal', balph: '40' }}
                  sizes='100vw'>
        <div className='hero-overlay bg-opacity-60'></div>
        <div className='hero-content text-center'>
          <div className='max-w-md'>
            <h1 className='text-3xl font-bold text-white'>{showLeaving ? `What's Leaving` : `Latest Episodes`}</h1>
            <p className='mb-5'>from Joseph Prince Ministries (USA)</p>
          </div>
        </div>
      </Background>
      <div className='container' data-theme='jpm'>
        <div>
          <List
            elements={videos}
            totalElements={videos.length}
            viewportWidth={200}
            listItem={el => <ListItem
              imageUrl={el.thumbnail_url}
              title={el.title}
              isHorizontalScroll={false}
              sermonId={el.episode_identifier_string ? el.episode_identifier_string : ''}
              date={el.youtube_published_at_diff}
              link={'/on-demand/watch/' + el.slug}
              itemIsLocked={el.is_locked}
              videoDuration={el.video_duration ?? ''}
            />}
          />
          <div className={`col-12 pt-4 pb-4`}>
            <div className='w-full border-b border-solid border-[#7D7D7D]'></div>
          </div>
        </div>
      </div>
    </>
  );
};

// Persistent layout Docs: https://inertiajs.com/pages#persistent-layouts
Latest.layout = page => <Layout title='Latest' children={page} data-theme='jpm' />;

export default Latest;
